define('flight-components/mixins/withActions',[], function() {

  var withActions = function withActions() {

    this.defaultAttrs({
      'actionSelector' : '[data-action]'
    });

    this.handleAction = function(ev, data) {
      ev.preventDefault();
      var $el = $(ev.target).closest(this.attr.actionSelector);
      this[$el.data('action')](ev);
    };

    this.after('initialize', function() {

      this.on('click', {
        'actionSelector': this.handleAction
      });

    });

  };

  return withActions;

});
